import { Container } from '@razz-team/ui-web';

export function AppLayout({ children }: { children: React.ReactNode }) {
  return <Container sx={{ height: '100vh', width: '100%', maxWidth: 1440 }}>{children}</Container>;
}
